import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { DialogService } from '../../../dialog';
import { FeedbackData, FeedbackInputType, FeedbackStyle } from '../../_models';

@Component({
	selector: 'app-feedback-confirm-dialog',
	templateUrl: './confirm-dialog.component.html',
	styleUrls: ['../../index.scss']
})
export class ConfirmDialogComponent implements OnInit {
	private dialogRefClose: () => void;

	public message: string;
	public placeholder: string;
	public inputType: FeedbackInputType;
	public style: FeedbackStyle;
	public confirmInput = new FormControl('', [Validators.required]);
	public contentClass = '';
	public eFeedbackInputType = FeedbackInputType;

	constructor(
		private dialogService: DialogService,
		private dialogRef: MatDialogRef<ConfirmDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public dialogData: FeedbackData
	) {
		// Store original close function and replace with unsaved version, remember to restore on use
		this.dialogRefClose = this.dialogService.interceptClose(this.dialogRef, this, this.closeDialog);
	}

	public ngOnInit(): void {
		this.message = this.dialogData.message || '';
		this.inputType = this.dialogData.inputType ?? FeedbackInputType.confirm;
		this.style = this.dialogData.style ?? FeedbackStyle.plain;
		this.placeholder = this.dialogData.placeholder || '';
		this.contentClass = this.dialogData?.contentClass ? this.dialogData.contentClass : '';
	}

	public closeDialog(value = null): void {
		this.dialogRefClose();

		if (this.dialogData.callback) this.dialogData.callback(value);
	}

	public save(): void {
		let value: any = true;

		if (this.inputType !== FeedbackInputType.confirm) {
			value = this.confirmInput.value;

			if (this.inputType === FeedbackInputType.number) {
				value = parseFloat(this.confirmInput.value);
			}
		}

		this.closeDialog(value);
	}
}
